/*
 * Modal view for adding and editing UI Configurations
 */

define(["marionette", "./template/uiConfigModalTemplate.html"], function (
  Marionette,
  UIConfigModalTemplate,
) {
  var UIConfigModalView = {};

  UIConfigModalView.uiConfigModalView = Marionette.ItemView.extend({
    template: UIConfigModalTemplate,
    applyFormToModel: function () {
      var touchPointId = this.$el.find("#configTP option:selected").val();
      var defaultTouchPointId = this.$el.find("#configDefaultTP option:selected").val();
      var languageId = this.$el.find("#configLanguage option:selected").val();
      var contexts = this.$el.find("#configContexts option:selected");
      var roles = this.$el.find("#configRoles option:selected");
      var qaMode = this.$el.find("#configQA").prop("checked");
      var contextIds = [];
      for (var i = 0; i < contexts.length; i++) {
        contextIds.push(parseInt(contexts[i].value, 10));
      }
      var roleIds = [];
      for (var i = 0; i < roles.length; i++) {
        roleIds.push(parseInt(roles[i].value, 10));
      }
      this.model.set("touchPointId", parseInt(touchPointId, 10));
      this.model.set("defaultTouchPointId", parseInt(defaultTouchPointId, 10));
      this.model.set("languageId", parseInt(languageId, 10));
      this.model.set("privilegedAreaRoleIds", roleIds);
      this.model.set("contextIds", contextIds);
      this.model.set("qaMode", qaMode);
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#uiConfigName")
        .html('<span class="error-message">' + errorMessage + "</span>")
        .hide()
        .fadeIn();
    },
    contextsError: function (errorMessage) {
      this.$el
        .find("#contextsError")
        .html('<br><span class="error-message">' + errorMessage + "</span>")
        .hide()
        .fadeIn();
    },
    setKey: function () {
      //insert the key into the modal
      this.$el.find("#uiConfigKey").text(this.model.get("password"));
    },
    modelEvents: {
      "change:password": "setKey",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    textboxes: {
      "#uiConfigName": {
        enableSelector: ["#uiConfigName", "#uiConfigNameLabel"],
        modelAttribute: "name",
        placeholder: "Name",
        textArea: false,
      },
    },
  });

  return UIConfigModalView;
});
